import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Modal from "@/features/shared/components/Modal/Modal";
import MissionTableFilters from "@/features/mission/components/MissionTableFilters";
import MissionTable from "@/features/mission/components/MissionTable";
import MissionPagination from "@/features/mission/components/MissionPagination";
import MissionForm from "@/features/mission/components/MissionForm";
import useMissions from "@/features/mission/hooks/useMissions";
import { toast } from "react-toastify";
const MissionsPage = () => {
    const [filters, setFilters] = useState({ label: '' });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedMission, setSelectedMission] = useState(null);
    const [errors, setErrors] = useState(null);
    const { missions, missionMetaData, missionsLoading, missionError, refetchMissions, handleAddMission, handleUpdateMission, handleDeleteMission, } = useMissions(currentPage, filters, false, rowsPerPage);
    const handleFilterChange = (filterName, value) => {
        setFilters((prev) => ({ ...prev, [filterName]: value }));
        setCurrentPage(1); // Reset to first page on filter change
    };
    const handleAddMissionClick = () => {
        setSelectedMission(null);
        setIsModalVisible(true);
    };
    const handleEdit = (mission) => {
        setSelectedMission(mission);
        setIsModalVisible(true);
    };
    const handleDelete = async (idMission) => {
        try {
            setErrors(null);
            await handleDeleteMission(idMission);
            toast.success("Mission supprimée");
        }
        catch (error) {
            setErrors(error.message);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    const handleSubmit = async (missionData) => {
        try {
            setErrors(null);
            if (selectedMission && missionData.id) {
                await handleUpdateMission(missionData);
                toast.success("Mission mise à jour avec succès");
            }
            else {
                await handleAddMission(missionData);
                toast.success("Mission créée avec succès");
            }
            setIsModalVisible(false);
            refetchMissions();
        }
        catch (error) {
            setErrors(error.message);
            toast.error(`Erreur : ${error.message}`);
        }
    };
    // If loading, display a spinner or message
    if (missionsLoading) {
        return _jsx("div", { className: "p-4", children: "Chargement des missions..." });
    }
    // If a critical error occurred, display a full-page error with a retry button
    if (missionError) {
        return (_jsxs("div", { className: "p-4 text-red-500", children: ["Erreur lors du chargement des missions : ", missionError, _jsx("button", { onClick: () => refetchMissions(), className: "ml-4 bg-blue-500 text-white px-2 py-1 rounded", children: "R\u00E9essayer" })] }));
    }
    return (_jsxs("div", { className: "p-4 bg-gray-50 min-h-screen", children: [_jsx("div", { className: "flex flex-col sm:flex-row justify-end", children: _jsx("div", { children: _jsx("button", { onClick: handleAddMissionClick, className: "mb-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600", children: "+ Ajouter une mission" }) }) }), _jsx(MissionTableFilters, { filters: filters, onFilterChange: handleFilterChange }), _jsx(MissionTable, { missions: missions, onEdit: handleEdit, onDelete: handleDelete }), missionMetaData && (_jsx(MissionPagination, { currentPage: missionMetaData.page ?? 1, totalPages: missionMetaData.totalPages ?? 1, limit: rowsPerPage, onPageChange: (page) => setCurrentPage(page), onLimitChange: (value) => {
                    setRowsPerPage(value);
                    setCurrentPage(1);
                } })), isModalVisible && (_jsx(Modal, { onClose: () => setIsModalVisible(false), children: _jsx(MissionForm, { initialData: selectedMission ?? undefined, onSubmit: handleSubmit, onCancel: () => setIsModalVisible(false) }) })), errors && (_jsxs("div", { className: "mt-4 p-3 bg-red-100 text-red-700 rounded", children: ["Erreur : ", errors] }))] }));
};
export default MissionsPage;
